import { VeltService } from './velt';
export class StoreService {
    constructor(plugin) {
        this.isSubscribed = false;
        this.globalStore = {
            editor: null,
            comments: [],
            filteredComments: [],
            selectedCommentsMap: new Map(),
        };
        // Global annotation storage
        this.globalAnnotationStore = new Map();
        /**
         * Helper to get and set annotations with debug messages
         */
        this.annotationStore = {
            get: (id) => {
                return this.globalAnnotationStore.get(id);
            },
            set: (id, data) => {
                this.globalAnnotationStore.set(id, data);
            },
            getAll: () => {
                return new Map(this.globalAnnotationStore);
            },
            clear: () => {
                this.globalAnnotationStore.clear();
            },
            remove: (id) => {
                this.globalAnnotationStore.delete(id);
            },
        };
        this.updateGlobalStore = (store) => {
            var _a, _b, _c;
            try {
                const comments = (store === null || store === void 0 ? void 0 : store.comments) || ((_a = this.globalStore) === null || _a === void 0 ? void 0 : _a.comments) || [];
                const newSelectedCommentsMap = (store === null || store === void 0 ? void 0 : store.selectedCommentsMap) || ((_b = this.globalStore) === null || _b === void 0 ? void 0 : _b.selectedCommentsMap) || new Map();
                const oldFilteredComments = ((_c = this.globalStore) === null || _c === void 0 ? void 0 : _c.filteredComments) || [];
                const filteredComments = comments.filter((annotation) => {
                    var _a;
                    return (((_a = annotation === null || annotation === void 0 ? void 0 : annotation.status) === null || _a === void 0 ? void 0 : _a.type) !== 'terminal' ||
                        (newSelectedCommentsMap === null || newSelectedCommentsMap === void 0 ? void 0 : newSelectedCommentsMap.get(annotation === null || annotation === void 0 ? void 0 : annotation.annotationId)));
                });
                // Create a Set of new annotation IDs for O(1) lookup
                const newAnnotationIds = new Set(filteredComments.map((annotation) => annotation === null || annotation === void 0 ? void 0 : annotation.annotationId));
                // Get IDs of removed comments
                const removedAnnotationIds = oldFilteredComments
                    .map((annotation) => annotation === null || annotation === void 0 ? void 0 : annotation.annotationId)
                    .filter((id) => id && !newAnnotationIds.has(id));
                // Remove comments from editor using just IDs
                removedAnnotationIds.forEach((annotationId) => {
                    var _a, _b;
                    if (((_a = this.globalStore) === null || _a === void 0 ? void 0 : _a.editor) && annotationId) {
                        this.plugin.editorService.removeVeltCommentFromEditor((_b = this.globalStore) === null || _b === void 0 ? void 0 : _b.editor, annotationId);
                    }
                });
                this.globalStore = Object.assign(Object.assign(Object.assign({}, this.globalStore), store), { filteredComments });
                this.highlightCommentsFromGlobalStore();
            }
            catch (error) {
                // handle error
                VeltService.catchError('Error updating global store:', error);
            }
        };
        this.highlightCommentsFromGlobalStore = () => {
            var _a, _b;
            try {
                const { editor, filteredComments } = this.globalStore;
                if (!editor || !filteredComments)
                    return;
                for (const annotation of filteredComments) {
                    const textToFind = (_b = (_a = annotation === null || annotation === void 0 ? void 0 : annotation.context) === null || _a === void 0 ? void 0 : _a.textEditorConfig) === null || _b === void 0 ? void 0 : _b.text;
                    if (textToFind) {
                        this.plugin.editorService.highlightTextWithVeltComment(editor, annotation);
                    }
                }
            }
            catch (error) {
                // handle error
                VeltService.catchError('Error highlighting comments from global store:', error);
            }
        };
        this.plugin = plugin;
        try {
            VeltService.subscribeToSelectedCommentsMap(this.plugin.editorId, (selectedCommentsMap) => {
                try {
                    this.updateGlobalStore({ selectedCommentsMap });
                }
                catch (error) {
                    VeltService.catchError('Error updating global store:', error);
                }
            });
        }
        catch (error) {
            VeltService.catchError('Error subscribing to selected comments map:', error);
        }
    }
}
StoreService.storeInstanceMap = new Map();
